import { Overlay } from './overlay';

export class AppointmentHubUrgentCare extends DrupalBehavior {
  $modal;
  $tabTitlesWrapper;
  $modalTabs;

  onContent(context) {
    this.$modal = $(
      once('appt-hub-urgent-care-modal', '#appt-hub-uc-modal', context)
    ).first();
    this.$tabTitlesWrapper = this.$modal.find('.tab-titles--wrapper');
    this.$modalTabs = this.$modal.find('.uc-modal-tab');

    this.setOpenCloseClickEvents(context);
    this.setUpTabTitles();
    this.setUpTabsContent();
  }

  setOpenCloseClickEvents(context) {
    const overlay = new Overlay();
    const $infoButton = $(
      once('appt-hub-urgent-care', '#urgent-care-info-button', context)
    ).first();
    const $closeButton = $(
      once('appt-hub-urgent-care', '#appt-hub-uc-modal--close-button', context)
    ).first();

    $infoButton.on('click', () => {
      this.openModal(overlay);
    });

    $closeButton.on('click', () => {
      this.closeModal(overlay);
    });

    this.$modal[0].addEventListener('click', (event) => {
      if (event.target.id === this.$modal.attr('id')) {
        this.closeModal(overlay);
      }
    });

    this.$modal[0].addEventListener('close', () => {
      this.setModalUIToClose(overlay);
    });
  }

  openModal(overlay) {
    this.$modal[0].showModal();
    this.$modal.addClass('active');
    this.$modalTabs.scrollTop(0);
    overlay.openOverlay();
    this.setModalTabHeight();
  }

  closeModal(overlay) {
    this.$modal[0].close();
    this.setModalUIToClose(overlay);
  }

  setModalUIToClose(overlay) {
    this.$modal.removeClass('active');
    overlay.closeOverlay();
  }

  setModalTabHeight() {
    const mobileBreakpoint = '991px';
    const mql = window.matchMedia(`(max-width: ${mobileBreakpoint})`);
    const $modalTitleWrapper = this.$modal.find('.title--wrapper').first();
    const offset =
      $modalTitleWrapper.outerHeight() + this.$tabTitlesWrapper.outerHeight();

    let newModalContentHeight = `calc(100% - ${offset}px)`;

    if (mql.matches) {
      newModalContentHeight = `${window.innerHeight - offset}px`;
    }

    this.$modalTabs.css('height', newModalContentHeight);
  }

  setUpTabsContent() {
    const $firstTab = this.$modal.find('.uc-modal-tab').first();

    $firstTab.parent().addClass('active');
    $firstTab.addClass('active');
  }

  setUpTabTitles() {
    const $tabTitles = this.$tabTitlesWrapper.find('button');

    $tabTitles.first().addClass('active');

    $tabTitles.each((index, titleElement) => {
      $(titleElement).on('click', () => {
        this.onTitleClick(index, titleElement);
      });
    });
  }

  onTitleClick(titleIndex, titleElement) {
    const $tabElements = $('.uc-modal-tab');

    $(titleElement).siblings().removeClass('active');
    $(titleElement).addClass('active');
    $(titleElement)[0].scrollIntoView({
      behavior: 'smooth',
      block: 'end',
      inline: 'center',
    });

    $tabElements.parent().removeClass('active');
    $tabElements.removeClass('active');
    $tabElements.eq(titleIndex).parent().addClass('active');
    $tabElements.eq(titleIndex).addClass('active');
  }
}

DrupalBehavior.register(
  'rush_theme.components',
  'appointment_urgent_care',
  AppointmentHubUrgentCare
);
